var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99407 7.00773C6.60354 7.39826 6.60354 8.03142 6.99407 8.42195L10.5792 12.0071L6.99407 15.5923C6.60354 15.9828 6.60354 16.616 6.99407 17.0065C7.38459 17.397 8.01776 17.397 8.40828 17.0065L11.9934 13.4213L15.5786 17.0065C15.9691 17.397 16.6023 17.397 16.9928 17.0065C17.3833 16.616 17.3833 15.9828 16.9928 15.5923L13.4076 12.0071L16.9928 8.42196C17.3833 8.03144 17.3833 7.39827 16.9928 7.00775C16.6022 6.61722 15.9691 6.61722 15.5786 7.00775L11.9934 10.5929L8.40828 7.00773C8.01776 6.61721 7.38459 6.61721 6.99407 7.00773Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconSvg);
export default __webpack_public_path__ + "static/media/cross-icon-svg.03b8765a96b5971cf3019c4e908c5c8b.svg";
export { ForwardRef as ReactComponent };